import { Navigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import AdminNavbar from "../Navbar/AdminNavbar";



export default function PrivateAdminRoute({ children }) {
    const {role} = useAuth() || {}
    
    return (role=== "admin") ? 
    <>
    <AdminNavbar/>
    {children}
    </>
      : <Navigate to="/admin" />;
}